'use client';

import Script from 'next/script';

import { useCookieConsent } from '@/hooks/use-cookie-consent';
import { useDeferredMount, useDelayedFlag } from '@/hooks/use-deferred-mount';
import { COOKIEYES_URL } from '@/utils/constants';
import { GoogleTagManagerScript } from '@/utils/google-tag-manager/google-tag-manager-script';
import { PixelFbNoscript } from '@/utils/pixel-fb/pixel-fb-noscript';
import { PixelFbScript } from '@/utils/pixel-fb/pixel-fb-script';

/**
 * The consent-gated tags of `pages/_app.tsx`, unchanged: CookieYes `lazyOnload` (not deferred —
 * the banner must appear without interaction); GTM on first interaction (10 s idle fallback)
 * + analytics consent; FB Pixel 2.5 s after that + advertisement consent. Nothing in development.
 */
export const ConsentScripts = () => {
  const isDeferredMountReady = useDeferredMount();
  const isSecondaryTagReady = useDelayedFlag(isDeferredMountReady, 2500);
  const consent = useCookieConsent();

  if (process.env.NODE_ENV === 'development') return null;

  return (
    <>
      <Script src={COOKIEYES_URL} strategy="lazyOnload" />
      {consent.advertisement && <PixelFbNoscript />}
      {isDeferredMountReady && consent.analytics && <GoogleTagManagerScript />}
      {isSecondaryTagReady && consent.advertisement && <PixelFbScript />}
    </>
  );
};
